<ul class="menu-links">
	<li>
		<a [routerLink]="subsidiariesPath" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
			<i class="menu-icon far fa-sitemap"></i>
			<span translate="Menu.Subsidiaries"></span>
		</a>
	</li>

	<li>
		<a [routerLink]="subsidiaryDetailCompanyPath" routerLinkActive="active">
			<i class="menu-icon far fa-file-alt"></i>
			<span translate="Menu.SubsidiaryDetailCompany"></span>
		</a>
	</li>

	<li>
		<a [routerLink]="subsidiaryDetailUsersPath" routerLinkActive="active">
			<i class="menu-icon far fa-users"></i>
			<span translate="Menu.SubsidiaryDetailUsers"></span>
		</a>
	</li>
</ul>